import React from 'react';
import { useWishlist } from './WishlistContext';
import Button from '../common/Button';

const RemoveFromWishlistButton = props => {
  const { loaded, isWishlisted, removeCard } = useWishlist();
  // Once removed the card is no longer in the context, which is also what makes
  // the "En wishlist" tag disappear elsewhere in the app.
  const removed = loaded && !isWishlisted(props.card.id);

  return (
    <Button
      className="w-full "
      iconClass={`fas ${removed ? 'fa-check' : 'fa-trash'}`}
      onClick={() => removeCard(props.card.id)}
      disabled={removed}>
      {removed ? 'Removido de wishlist' : 'Remover de wishlist'}
    </Button>
  );
};

export default RemoveFromWishlistButton;
